import { Flex, Loader, Text } from '@mantine/core';
import { type OverviewSubject, useOverview } from 'src/clients/hooks/useOverview';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { MeetingDetailsCard } from './MeetingDetailsCard';

type Props = {
  subject: OverviewSubject | null;
  title: string;
};

export function MeetingOverviewCard({ subject, title }: Props) {
  const { overview, isLoading, error } = useOverview(subject);

  if (isLoading) {
    return (
      <MeetingDetailsCard title={title}>
        <Flex align="center" gap="xxs">
          <Loader size="sm" />
          <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.7">
            Preparing the overview
          </Text>
        </Flex>
      </MeetingDetailsCard>
    );
  }

  // A missing overview (404) is stripped to no error by the hook, so a truthy
  // error here is a real failure and should read differently from "no data".
  if (error) {
    return (
      <MeetingDetailsCard title={title}>
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.7">
          The overview could not be loaded. Please try again later.
        </Text>
      </MeetingDetailsCard>
    );
  }

  const hasContent = !!overview && overview.summary.trim().length > 0;

  if (!hasContent) {
    return (
      <MeetingDetailsCard title={title}>
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.7">
          No overview available yet.
        </Text>
      </MeetingDetailsCard>
    );
  }

  return (
    <MeetingDetailsCard title={title}>
      <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
        {overview.summary}
      </Text>
    </MeetingDetailsCard>
  );
}
